/* eslint-disable vue/no-reserved-component-names */
/* eslint-disable vue/multi-word-component-names */
import type { App } from 'vue';
import HeaderBar from './header-bar/HeaderBar.vue';
import RecordSaveBar from './record-save-bar';
import GlobalToast from './global-toast';
import LoadingApi from './loading-api/LoadingApi.vue';
import { DeleteFooter } from './delete-footer';
import { OrderStatusTag } from './order-status-tag';
import { DeliveryAppTag } from './delivery-app-tag';
import { RefundStatusTag } from './refund-status-tag';
import { IssueTag } from './issue-tag';

import { Button } from '@centric-os/components/src/core/buttons/button';
import { IconButton } from '@centric-os/components/src/core/buttons/icon-button';
import { SelectButton } from '@centric-os/components/src/core/buttons/select-button';
import { SplitButton } from '@centric-os/components/src/core/buttons/split-button';
import { TextButton } from '@centric-os/components/src/core/buttons/text-button';
import { ToggleButton } from '@centric-os/components/src/core/buttons/toggle-button';
import { Accordion } from '@centric-os/components/src/core/containers/accordion';
import { AccordionTab } from '@centric-os/components/src/core/containers/accordion-tab';
import { ActionBar } from '@centric-os/components/src/composed/misc/action-bar';
import { AppLogo } from '@centric-os/components/src/composed/media/app-logo';
import { AutoComplete } from '@centric-os/components/src/core/controls/autocomplete';
import { AutoCompleteBox } from '@centric-os/components/src/core/controls/autocomplete-box';
import { AutocompleteBoxField } from '@centric-os/components/src/composed/validators/autocomplete-box-field';
import { AutocompleteField } from '@centric-os/components/src/composed/validators/autocomplete-field';
import { Avatar } from '@centric-os/components/src/core/misc/avatar';
import { Breadcrumb } from '@centric-os/components/src/core/menus/breadcrumb';
import { Calendar } from '@centric-os/components/src/core/controls/calendar';
import { CalendarField } from '@centric-os/components/src/composed/validators/calendar-field';
import { Card } from '@centric-os/components/src/core/containers/cards/card';
import { Checkbox } from '@centric-os/components/src/core/controls/checkbox';
import { CheckboxField } from '@centric-os/components/src/composed/validators/checkbox-field';
import { Chip } from '@centric-os/components/src/core/misc/chip';
import { Chips } from '@centric-os/components/src/core/controls/chips';
import { ChipsField } from '@centric-os/components/src/composed/validators/chips-field';
import { Col1 } from '@centric-os/components/src/core/layouts/columns/col-1';
import { Col2 } from '@centric-os/components/src/core/layouts/columns/col-2';
import { Col3 } from '@centric-os/components/src/core/layouts/columns/col-3';
import { Col4 } from '@centric-os/components/src/core/layouts/columns/col-4';
import { Col5 } from '@centric-os/components/src/core/layouts/columns/col-5';
import { Col6 } from '@centric-os/components/src/core/layouts/columns/col-6';
import { Col7 } from '@centric-os/components/src/core/layouts/columns/col-7';
import { Col8 } from '@centric-os/components/src/core/layouts/columns/col-8';
import { Col9 } from '@centric-os/components/src/core/layouts/columns/col-9';
import { Col10 } from '@centric-os/components/src/core/layouts/columns/col-10';
import { Col11 } from '@centric-os/components/src/core/layouts/columns/col-11';
import { Col12 } from '@centric-os/components/src/core/layouts/columns/col-12';
import { Column, DataTable } from '@centric-os/components/src/core/data/data-table';
import { ConfirmDialog } from '@centric-os/components/src/core/overlays/confirm-dialog';
import { ContentPage } from '@centric-os/components/src/composed/pages/content-page';
import { ContentPageForm } from '@centric-os/components/src/composed/forms/content-page-form';
import { ContentSubHeader } from '@centric-os/components/src/core/misc/headers/content-sub-header';
import { ContextMenu } from '@centric-os/components/src/core/menus/context-menu';
import { CurrencyField } from '@centric-os/components/src/composed/validators/currency-field';
import { CustomAccordion } from '@centric-os/components/src/core/containers/custom-accordion';
import { DataTableLayout } from '@centric-os/components/src/core/layouts/data-table-layout';
import { DateCell } from '@centric-os/components/src/core/data/data-table/cells/date-cell';
import { Dialog } from '@centric-os/components/src/core/overlays/dialog-modal';
import { DialogForm } from '@centric-os/components/src/composed/forms/dialog-form';
import { Divider } from '@centric-os/components/src/core/containers/divider';
import { Dropdown } from '@centric-os/components/src/core/controls/dropdown';
import { DropdownField } from '@centric-os/components/src/composed/validators/dropdown-field';
import { Field } from '@centric-os/components/src/core/misc/field';
import { FieldArrayValidator } from '@centric-os/components/src/composed/validators/field-array-validator';
import { FieldValidator } from '@centric-os/components/src/composed/validators/field-validator';
import { FileUpload } from '@centric-os/components/src/core/file/file-upload';
import { Form } from '@centric-os/components/src/composed/forms/form';
import { FullCalendar } from '@centric-os/components/src/core/misc/full-calendar';
import { Grid } from '@centric-os/components/src/core/layouts/grids/grid';
import { Image } from '@centric-os/components/src/core/media/image';
import { ImageListItem } from '@centric-os/components/src/composed/media/image-list-item';
import { ImageSelect } from '@centric-os/components/src/composed/file/image-select';
import { ImageSelectField } from '@centric-os/components/src/composed/validators/image-select-field';
import { InputCurrency } from '@centric-os/components/src/core/controls/input-currency';
import { InputMask } from '@centric-os/components/src/core/controls/input-mask';
import { InputNumber } from '@centric-os/components/src/core/controls/input-number';
import { InputSwitch } from '@centric-os/components/src/core/controls/input-switch';
import { InputSwitchStatus } from '@centric-os/components/src/core/controls/input-switch-status';
import { InputText } from '@centric-os/components/src/core/controls/input-text';
import { InputTextSearch } from '@centric-os/components/src/core/controls/input-text-search';
import { ListBox } from '@centric-os/components/src/core/controls/list-box';
import { ListBoxField } from '@centric-os/components/src/composed/validators/list-box-field';
import { ListCell } from '@centric-os/components/src/core/data/data-table/cells/list-cell';
import { MaskField } from '@centric-os/components/src/composed/validators/mask-field';
import { Menu } from '@centric-os/components/src/core/menus/menu';
import { Message } from '@centric-os/components/src/core/messages/message';
import { MultiSelect } from '@centric-os/components/src/core/controls/multi-select';
import { MultiSelectField } from '@centric-os/components/src/composed/validators/multi-select-field';
import { NumberField } from '@centric-os/components/src/composed/validators/number-field';
import { OrderList } from '@centric-os/components/src/core/data/order-list';
import { OverlayPanel } from '@centric-os/components/src/core/overlays/overlay-panel';
import { Page } from '@centric-os/components/src/core/containers/pages/page';
import { PageAccordion } from '@centric-os/components/src/composed/pages/page-accordion';
import { PagePanel } from '@centric-os/components/src/composed/pages/page-panel';
import { Paginator } from '@centric-os/components/src/core/data/paginator';
import { Password } from '@centric-os/components/src/core/controls/password';
import { PasswordField } from '@centric-os/components/src/composed/validators/password-field';
import { PickList } from '@centric-os/components/src/core/data/pick-list';
import { PrimaryRecordLayout } from '@centric-os/components/src/core/layouts/primary-record-layout';
import { ProgressBar } from '@centric-os/components/src/core/misc/progress-bar';
import { ProgressSpinner } from '@centric-os/components/src/core/misc/progress-spinner';
import { RadioButton } from '@centric-os/components/src/core/controls/radio-button';
import { RadioButtonField } from '@centric-os/components/src/composed/validators/radiobutton-field';
import { RecordLayout } from '@centric-os/components/src/core/layouts/record-layout';
import { ReorderList } from '@centric-os/components/src/core/misc/reorder-list';
import { ReorderListField } from '@centric-os/components/src/composed/validators/reorder-list-field';
import { SecondaryRecordLayout } from '@centric-os/components/src/core/layouts/secondary-record-layout';
import { SelectButtonField } from '@centric-os/components/src/composed/validators/select-button-field';
import { Sidebar } from '@centric-os/components/src/core/overlays/sidebar';
import { SidebarForm } from '@centric-os/components/src/composed/forms/sidebar-form';
import { SingleColumnLayout } from '@centric-os/components/src/core/layouts/single-column-layout';
import { Skeleton } from '@centric-os/components/src/core/misc/skeleton';
import { Splitter, SplitterPanel } from '@centric-os/components/src/core/containers/splitter';
import { SplitterLayout } from '@centric-os/components/src/core/layouts/splitter-layout';
import { StatusCard } from '@centric-os/components/src/core/containers/cards/status-card';
import { StatusTag } from '@centric-os/components/src/core/misc/tags/status-tag';
import { Sticky } from '@centric-os/components/src/core/containers/sticky';
import { StoreTable } from '@centric-os/components/src/composed/tables/store-table';
import { SwitchField } from '@centric-os/components/src/composed/validators/switch-field';
import { SwitchStatusField } from '@centric-os/components/src/composed/validators/switch-status-field';
import { TabMenu } from '@centric-os/components/src/core/menus/tab-menu';
import { TabPanel, TabView } from '@centric-os/components/src/core/containers/tab-view';
import { TableEmpty } from '@centric-os/components/src/core/layouts/table-empty';
import { TableHeader } from '@centric-os/components/src/core/layouts/table-header';
import { TableLayout } from '@centric-os/components/src/core/layouts/table-layout';
import { TableSearch } from '@centric-os/components/src/composed/tables/table-search';
import { Tag } from '@centric-os/components/src/core/misc/tags/tag';
import { TertiaryRecordLayout } from '@centric-os/components/src/core/layouts/tertiary-record-layout';
import { Textarea } from '@centric-os/components/src/core/controls/textarea';
import { TextareaField } from '@centric-os/components/src/composed/validators/textarea-field';
import { TextField } from '@centric-os/components/src/composed/validators/text-field';
import { Toast } from '@centric-os/components/src/core/messages/toast';
import { Toolbar } from '@centric-os/components/src/core/layouts/toolbar';
import { Tree } from '@centric-os/components/src/core/data/tree';
import { TreeTable } from '@centric-os/components/src/core/data/tree-table';
import { TriStateCheckbox } from '@centric-os/components/src/core/controls/tri-state-checkbox';
import { UserCell } from '@centric-os/components/src/core/data/data-table/cells/user-cell';
import { UserLinkCell } from '@centric-os/components/src/composed/tables/cells/user-link-cell';

export const registerAppComponents = (app: App) => {
  app.component('Accordion', Accordion);
  app.component('AccordionTab', AccordionTab);
  app.component('ActionBar', ActionBar);
  app.component('AppLogo', AppLogo);
  app.component('AutoComplete', AutoComplete);
  app.component('AutocompleteField', AutocompleteField);
  app.component('AutoCompleteBox', AutoCompleteBox);
  app.component('AutocompleteBoxField', AutocompleteBoxField);
  app.component('Avatar', Avatar);
  app.component('Breadcrumb', Breadcrumb);
  app.component('Button', Button);
  app.component('Calendar', Calendar);
  app.component('CalendarField', CalendarField);
  app.component('Card', Card);
  app.component('Checkbox', Checkbox);
  app.component('CheckboxField', CheckboxField);
  app.component('Chip', Chip);
  app.component('Chips', Chips);
  app.component('ChipsField', ChipsField);
  app.component('Col1', Col1);
  app.component('Col2', Col2);
  app.component('Col3', Col3);
  app.component('Col4', Col4);
  app.component('Col5', Col5);
  app.component('Col6', Col6);
  app.component('Col7', Col7);
  app.component('Col8', Col8);
  app.component('Col9', Col9);
  app.component('Col10', Col10);
  app.component('Col11', Col11);
  app.component('Col12', Col12);
  app.component('Column', Column);
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('ContentPage', ContentPage);
  app.component('ContentPageForm', ContentPageForm);
  app.component('ContentSubHeader', ContentSubHeader);
  app.component('ContextMenu', ContextMenu);
  app.component('CurrencyField', CurrencyField);
  app.component('CustomAccordion', CustomAccordion);
  app.component('DataTable', DataTable);
  app.component('DataTableLayout', DataTableLayout);
  app.component('DateCell', DateCell);
  app.component('DeleteFooter', DeleteFooter);
  app.component('DeliveryAppTag', DeliveryAppTag);
  app.component('Dialog', Dialog);
  app.component('DialogForm', DialogForm);
  app.component('Divider', Divider);
  app.component('Dropdown', Dropdown);
  app.component('DropdownField', DropdownField);
  app.component('Field', Field);
  app.component('FieldArrayValidator', FieldArrayValidator);
  app.component('FieldValidator', FieldValidator);
  app.component('FileUpload', FileUpload);
  app.component('Form', Form);
  app.component('FullCalendar', FullCalendar);
  app.component('GlobalToast', GlobalToast);
  app.component('HeaderBar', HeaderBar);
  app.component('Grid', Grid);
  app.component('IconButton', IconButton);
  app.component('Image', Image);
  app.component('ImageListItem', ImageListItem);
  app.component('ImageSelect', ImageSelect);
  app.component('ImageSelectField', ImageSelectField);
  app.component('InputCurrency', InputCurrency);
  app.component('InputMask', InputMask);
  app.component('InputNumber', InputNumber);
  app.component('InputSwitch', InputSwitch);
  app.component('InputSwitchStatus', InputSwitchStatus);
  app.component('InputText', InputText);
  app.component('InputTextSearch', InputTextSearch);
  app.component('ListBox', ListBox);
  app.component('ListBoxField', ListBoxField);
  app.component('ListCell', ListCell);
  app.component('LoadingApi', LoadingApi);
  app.component('MaskField', MaskField);
  app.component('Menu', Menu);
  app.component('Message', Message);
  app.component('MultiSelect', MultiSelect);
  app.component('MultiSelectField', MultiSelectField);
  app.component('NumberField', NumberField);
  app.component('OrderList', OrderList);
  app.component('OrderStatusTag', OrderStatusTag);
  app.component('OverlayPanel', OverlayPanel);
  app.component('Page', Page);
  app.component('PageAccordion', PageAccordion);
  app.component('PagePanel', PagePanel);
  app.component('Paginator', Paginator);
  app.component('Password', Password);
  app.component('PasswordField', PasswordField);
  app.component('PickList', PickList);
  app.component('PrimaryRecordLayout', PrimaryRecordLayout);
  app.component('ProgressBar', ProgressBar);
  app.component('ProgressSpinner', ProgressSpinner);
  app.component('RadioButton', RadioButton);
  app.component('RadioButtonField', RadioButtonField);
  app.component('RecordLayout', RecordLayout);
  app.component('RecordSaveBar', RecordSaveBar);
  app.component('RefundStatusTag', RefundStatusTag);
  app.component('IssueTag', IssueTag);
  app.component('ReorderList', ReorderList);
  app.component('ReorderListField', ReorderListField);
  app.component('SecondaryRecordLayout', SecondaryRecordLayout);
  app.component('SelectButton', SelectButton);
  app.component('SelectButtonField', SelectButtonField);
  app.component('Sidebar', Sidebar);
  app.component('SidebarForm', SidebarForm);
  app.component('SingleColumnLayout', SingleColumnLayout);
  app.component('Skeleton', Skeleton);
  app.component('Splitter', Splitter);
  app.component('SplitButton', SplitButton);
  app.component('SplitterLayout', SplitterLayout);
  app.component('SplitterPanel', SplitterPanel);
  app.component('StatusCard', StatusCard);
  app.component('StatusTag', StatusTag);
  app.component('Sticky', Sticky);
  app.component('StoreTable', StoreTable);
  app.component('SwitchField', SwitchField);
  app.component('SwitchStatusField', SwitchStatusField);
  app.component('TabMenu', TabMenu);
  app.component('TabPanel', TabPanel);
  app.component('TabView', TabView);
  app.component('TableEmpty', TableEmpty);
  app.component('TableHeader', TableHeader);
  app.component('TableLayout', TableLayout);
  app.component('TableSearch', TableSearch);
  app.component('Tag', Tag);
  app.component('TertiaryRecordLayout', TertiaryRecordLayout);
  app.component('Textarea', Textarea);
  app.component('TextareaField', TextareaField);
  app.component('TextButton', TextButton);
  app.component('TextField', TextField);
  app.component('Toast', Toast);
  app.component('ToggleButton', ToggleButton);
  app.component('Toolbar', Toolbar);
  app.component('Tree', Tree);
  app.component('TreeTable', TreeTable);
  app.component('TriStateCheckbox', TriStateCheckbox);
  app.component('UserCell', UserCell);
  app.component('UserLinkCell', UserLinkCell);
};
